/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { ChevronLeftIcon } from "@dotnet/telematics-design-system";

interface GoBackProps {
  onGoBack: () => void;
  text: string;
}

const GoBack = ({ onGoBack, text }: GoBackProps) => {
  return (
    <div
      data-testid="go-back"
      css={css({
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      })}
      onClick={onGoBack}
    >
      <ChevronLeftIcon
        style={{ width: "20px", height: "20px" }}
        data-testid="ChevronLeftRoundedIcon"
      />
      <Typography variant="body2Medium">{text}</Typography>
    </div>
  );
};

export default GoBack;
